export default function Configure($stateProvider) {
    $stateProvider.state('locataires', {
        parent: 'common',
        url: '/locataires',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('locataires.list', {
        url: '/:genre/list',
        template: '<sites></sites>',
        rights: { domain: 'sitelocat', right: 'read', application: 'qse' },
        ncyBreadcrumb: {
            label: '{{ "SITES.BREADCRUMBS.SITES_LOCATAIRES_LIST" | translate}}'
        }
    });

    $stateProvider.state('locataires.niveaux', {
        url: '/:genre/niveaux',
        template: '<site-config-niveaux></site-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher sites > niveaux
            parent: 'locataires.list({genre: "locataires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('locataires.list.detail', {
        url: '/:genre/{id}',
        template: '<site-detail></site-detail>',
        ncyBreadcrumb: {
            parent: 'locataires.list({genre: "locataires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('locataires.new', {
        url: '/:genre/new',
        template: '<site-form></site-form>',
        rights: { domain: 'sitelocat', right: 'create' },
        ncyBreadcrumb: {
            parent: 'locataires.list({genre: "locataires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_NEW_LOCATAIRE" | translate}}'
        },
        search: 'SITES.BREADCRUMBS.SITE_NEW_LOCATAIRE'
    });

    $stateProvider.state('locataires.edit', {
        url: '/:genre/{id}/edit',
        template: '<site-form></site-form>',
        rights: { domain: 'sitelocat', right: 'update' },
        ncyBreadcrumb: {
            parent: 'locataires.list({genre: "locataires"})',
            label: '{{ "SITES.BREADCRUMBS.SITE_EDIT_LOCATAIRE" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
